import React, { createContext, useState, useContext } from 'react';

const OverlayContext = createContext();

export const useOverlay = () => {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error('useOverlay must be used within an OverlayProvider');
  }
  return context;
};

export const OverlayProvider = ({ children }) => {
  const [overlayData, setOverlayData] = useState({
    isOpen: false,
    imageName: ''
  });

  const [bubblesEnabled, setBubblesEnabled] = useState(true);

  const openOverlay = (imageName) => {
    setOverlayData({ isOpen: true, imageName });
  };

  const closeOverlay = () => {
    setOverlayData({ isOpen: false, imageName: '' });
  };

  const toggleBubbles = () => {
    setBubblesEnabled(!bubblesEnabled);
  };

  return (
    <OverlayContext.Provider value={{
      overlayData,
      openOverlay,
      closeOverlay,
      bubblesEnabled,
      toggleBubbles
    }}>
      {children}
    </OverlayContext.Provider>
  );
};
